import fw_logos from './fw-logos';
import agGridSvg from './ag-grid.svg';
import agGridInvertedSvg from './ag-grid-inverted.svg';
import angularJsSvg from './angularjs.svg';
import stackblitzSvg from './stackblitz.svg';
import reactuiSvg from './reactui.svg';
import thinksterSvg from './thinkster.svg';
import youtubeSvg from './youtube.svg';
import reactHooksSvg from './reactHooks.svg'
import codesandboxSvg from './codesandbox.svg'

import plunkerSvg from './plunker.svg'

const logos = {
    ...fw_logos,
    agGrid: agGridSvg,
    agGridInverted: agGridInvertedSvg,
    angularjs: angularJsSvg,
    plunker: plunkerSvg,
    stackblitz: stackblitzSvg,
    reactui: reactuiSvg,
    reactHooks: reactHooksSvg,
    thinkster: thinksterSvg,
    youtube: youtubeSvg,
    codesandbox:codesandboxSvg
};

export default logos;
